import React, { useEffect } from 'react'
import './About.css'
import ME from '../../assests/PICS.JPG'
import Aos from 'aos'
import 'aos/dist/aos.css'

const About = () => {

  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, [])

  return (
    <section id='about' data-aos="fade-up">
      <h5>Get to know</h5>
      <h2>About Me</h2>

      <div className='container about__container'>

        <div className='about__me'>

          <div className='about__me-image'> 

          <img src={ME} alt='Authors__pics' className='about__image'/>
          </div>

        </div>

        <div className='about__content'>

          {/* <div className='about__cards'>

            <article className='about__card'>
              <FaAward className='about__icon'/>
              <h5>Experience</h5>
              <small> 3+ Years Working</small>

            </article>

            <article className='about__card'>
              <FiUsers className='about__icon'/>
              <h5>Clients</h5>
              <small> 200+ worldwide</small>

            </article>

            <article className='about__card'>
              <VscFolderLibrary className='about__icon'/>
              <h5>Projects</h5>
              <small> 80+ Completed</small>

            </article>
          </div> */}

          <p>
            I'm a Frontend developer<span>🌟🌟</span> with understanding of Javascript library (ReactJS) 
            and ReactJS framework (NextJS) and a graduate from Electrical/Electronics Engineering<span>✨✨</span>. 
            As a fast-pace leaner, I'm willing to learn more tools and practices needed from me to 
            perform or carryout your Job, i have worked with a few technology which i have brought up Projects from 
            kindly locate projects in my project section below<span>🎊🎊</span>
          </p>

          <a href='#contact' className='btn btn-primary'>Let's Talk<span className='joy__tears'>😍😍</span></a>
         

        </div>
      </div>
    </section>
  )
}

export default About